import { Component, Input, HostBinding, HostListener, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

// Must match the CSS custom property values in the SCSS
const DESKTOP_POSTER_VW = 100 / (1.05 * 4.2);  // 22.676vw
const MOBILE_POSTER_VW  = 100 / (1.05 * 1.2);  // 79.365vw
const GAP_RATIO         = 0.0648;                // gap = 1.47vw / 22.68vw desktop poster width
const MOBILE_BREAKPOINT = 640;

@Component({
    selector: 'app-poster-bg-3row',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './poster-bg-3row.component.html',
    styleUrls: ['./poster-bg-3row.component.scss']
})
export class PosterBg3RowComponent implements OnInit, OnChanges {
    @Input() posters: string[] = [];
    @Input() overlay = '';
    @Input() overlayMob = '';
    @Input() isReversed: boolean = false;
    @Input() isMobile: boolean = false;

    @HostBinding('class.reversed') get reversedClass() { return this.isReversed; }

    @HostBinding('style.--translate-dist') translateDist = '0vw';
    @HostBinding('style.--cell')           cell          = '0vw';
    @HostBinding('style.--offset-2')       offset2       = '0vw';
    @HostBinding('style.--offset-3')       offset3       = '0vw';

    ngOnInit()    { this.calcTranslateDist(); }
    ngOnChanges() { this.calcTranslateDist(); }

    @HostListener('window:resize')
    onResize() { this.calcTranslateDist(); }

    get row1(): string[] {
        return [...this.posters, ...this.posters];
    }

    get row2(): string[] {
        const rev = [...this.posters].reverse();
        return [...rev, ...rev];
    }

    get row3(): string[] {
        return [...this.posters, ...this.posters];
    }

    private calcTranslateDist() {
        if (!this.posters.length) return;
        const isMobile = typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;
        const posterW  = isMobile ? MOBILE_POSTER_VW : DESKTOP_POSTER_VW;
        const cell     = posterW * (1 + GAP_RATIO);
        const total    = this.posters.length * cell;
        this.cell          = `${cell.toFixed(3)}vw`;
        this.translateDist = `${total.toFixed(3)}vw`;
        this.offset2       = `${(total / 3).toFixed(3)}vw`;
        this.offset3       = `${(total * 2 / 3 + posterW * (1 + GAP_RATIO) ).toFixed(3)}vw`;

        if(this.isMobile) {
            this.offset2       = `${(total / 3).toFixed(3)}vw`;
            this.offset3       = `${(total * 2 / 3 + posterW * (2 + GAP_RATIO) ).toFixed(3)    }vw`;
        }
    }
}
